module.exports = __webpack_public_path__ + "static/camera2-56f92a14967ed04fb31c170f8d496e93.jpg";